export default "__VITE_ASSET__DzcC4BUL__"